import { Pages } from '.generated/Project.CW.model';
import type { WithContext, MedicalWebPage } from 'schema-dts';
import { stripHtmlTags } from 'lib/utils/string-utils';

export const buildGeneralPageJsonLd = (
  data: Pages.GeneralPageT1 | Pages.GeneralPageT2,
  pageUrl: string
): WithContext<MedicalWebPage> => ({
  '@context': 'https://schema.org',
  '@type': 'MedicalWebPage',
  '@id': pageUrl,
  name: data.fields?.Title?.value,
  description: stripHtmlTags(data.fields?.Description?.value),
  url: pageUrl,
});
